import { mutatorAction } from "satcheljs";
import { TeamInfoStore } from "sh-stores";

export default mutatorAction('DELETE_TEAM_IN_STORE', function deleteTeamInStore(teamId: string) {
    if (TeamInfoStore().teams) {
        // delete team from the teams map
        TeamInfoStore().teams.delete(teamId);
    }
});
